module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Billionaire's Bride of Innocence")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "application/xhtml+xml; charset=utf-8",
      "http-equiv": "content-type"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm01"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagei"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("“Why me?”")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("“Because you were perfect,” came his smoothly delivered reply.")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("“Did you mind that I was a virgin?”")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("“Mind? Why would I have minded?”")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("She shrugged. “Because I was inexperienced. I dare say after a while you found me rather boring in bed.”")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("“Megan, darling. I am being honest. I never thought you boring in bed. At the same time that doesn’t mean that I would not have one day moved our love life in a more…imaginative direction. I get the impression you wouldn’t object if I did during our second honeymoon….”")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("“What do you mean by a more…imaginative direction?”")])]), _c('p', {
    staticClass: "paraNoIndent1"
  }, [_c('span', [_vm._v("“I don’t think this is the time or place to go into detail. If you trust me, however, as the more experienced partner, I will show you when we get to Dream Island.” His eyes caressed hers in the most seductive fashion.")])])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "pagei"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4530504a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/billionairesbrideofinnocencethe_fm01.vue
// module id = 57
// module chunks = 0